
const TokyoSvg = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 128 129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M56.5 87.3138L54 74.3289C54 72 73.446 72 73.446 74.3289L70.5252 87.3138C70.5252 88.7742 56.5 88.7742 56.5 87.3138Z"
        fill="var(--background-tertiary)"
        stroke="#0085FF"
      />
      <path d="M54 74.1699C54 76 73.5 76 73.4461 74.1699" stroke="#0085FF" />
      <path d="M68 23L69 75" stroke="#0085FF" />
      <path d="M69.5 88L71 128" stroke="#0085FF" />
      <path d="M60 23.5L58.5 75" stroke="#0085FF" />
      <path d="M57.5 87.5L56 128" stroke="#0085FF" />
      <path
        d="M58 46.26V43.2167C58 42.0287 69.5 42.0281 69.5 43.2162V46.26C69.5 48.0859 58 47.6801 58 46.26Z"
        fill="var(--background-tertiary)"
        stroke="#0085FF"
      />
      <path d="M58 43.2174C58 44.5 69.5 44.5 69.5 43.2168" stroke="#0085FF" />
      <path
        d="M60 23.5C60 24.1667 68 24.1666 68 23.5C68 22.8334 60 22.8333 60 23.5Z"
        stroke="#0085FF"
      />
      <path d="M64 24V0" stroke="#0085FF" />
    </svg>
  );
};

export default TokyoSvg;
